// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thumbnail-dialog {
  padding: 24px;
  min-width: 600px;
  max-width: 800px;
}
.thumbnail-dialog .dialog-header {
  margin-bottom: 24px;
}
.thumbnail-dialog .dialog-header h2 {
  font-size: 20px;
  font-weight: 500;
  color: #030303;
  margin: 0 0 8px 0;
}
.thumbnail-dialog .dialog-header p {
  font-size: 14px;
  color: #606060;
  margin: 0;
}
.thumbnail-dialog .dialog-content {
  margin-bottom: 24px;
}
.thumbnail-dialog .thumbnail-options {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.thumbnail-dialog .thumbnail-options .option-card {
  flex: 1;
  min-width: 280px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s;
}
.thumbnail-dialog .thumbnail-options .option-card:hover {
  border-color: #ccc;
}
.thumbnail-dialog .thumbnail-options .option-card.selected {
  border-color: #065fd4;
  background-color: #f0f7ff;
}
.thumbnail-dialog .thumbnail-options .option-card .option-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.thumbnail-dialog .thumbnail-options .option-card .option-header input[type=radio] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.thumbnail-dialog .thumbnail-options .option-card .option-header label {
  font-size: 14px;
  font-weight: 500;
  color: #030303;
  cursor: pointer;
  margin: 0;
}
.thumbnail-dialog .thumbnail-options .option-card .thumbnail-preview {
  width: 100%;
  height: 200px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9f9f9;
}
.thumbnail-dialog .thumbnail-options .option-card .thumbnail-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.thumbnail-dialog .thumbnail-options .option-card .thumbnail-preview .no-thumbnail {
  color: #909090;
  font-size: 14px;
}
.thumbnail-dialog .thumbnail-options .option-card .thumbnail-preview .upload-area {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
}
.thumbnail-dialog .thumbnail-options .option-card .thumbnail-preview .upload-area .upload-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 20px;
  border-radius: 4px;
  transition: background-color 0.2s;
}
.thumbnail-dialog .thumbnail-options .option-card .thumbnail-preview .upload-area .upload-label:hover {
  background-color: #f0f0f0;
}
.thumbnail-dialog .thumbnail-options .option-card .thumbnail-preview .upload-area .upload-label mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #606060;
}
.thumbnail-dialog .thumbnail-options .option-card .thumbnail-preview .upload-area .upload-label span {
  font-size: 14px;
  color: #606060;
}
.thumbnail-dialog .thumbnail-options .option-card .thumbnail-preview .upload-area .upload-progress {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 0 20px;
}
.thumbnail-dialog .thumbnail-options .option-card .thumbnail-preview .upload-area .upload-progress progress {
  width: 100%;
  height: 8px;
}
.thumbnail-dialog .thumbnail-options .option-card .thumbnail-preview .upload-area .upload-progress span {
  font-size: 12px;
  color: #606060;
}
.thumbnail-dialog .thumbnail-options .option-card .upload-btn {
  margin-top: 12px;
  width: 100%;
  padding: 10px;
  background: #065fd4;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
.thumbnail-dialog .thumbnail-options .option-card .upload-btn:hover:not(:disabled) {
  background: #0d47a1;
}
.thumbnail-dialog .thumbnail-options .option-card .upload-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}
.thumbnail-dialog .dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}
.thumbnail-dialog .dialog-actions button {
  padding: 10px 24px;
  border-radius: 18px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}
.thumbnail-dialog .dialog-actions button.btn-secondary {
  background: transparent;
  color: #030303;
}
.thumbnail-dialog .dialog-actions button.btn-secondary:hover {
  background: #f0f0f0;
}
.thumbnail-dialog .dialog-actions button.btn-primary {
  background: #065fd4;
  color: #fff;
}
.thumbnail-dialog .dialog-actions button.btn-primary:hover {
  background: #0d47a1;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/thumbnail-selection-dialog/thumbnail-selection-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;AACF;AACE;EACE,mBAAA;AACJ;AACI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AACN;AAEI;EACE,eAAA;EACA,cAAA;EACA,SAAA;AAAN;AAIE;EACE,mBAAA;AAFJ;AAKE;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAHJ;AAKI;EACE,OAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;AAHN;AAKM;EACE,kBAAA;AAHR;AAMM;EACE,qBAAA;EACA,yBAAA;AAJR;AAOM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AALR;AAOQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;AALV;AAQQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;AANV;AAUM;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AARR;AAUQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AARV;AAWQ;EACE,cAAA;EACA,eAAA;AATV;AAYQ;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAVV;AAYU;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,iCAAA;AAVZ;AAYY;EACE,yBAAA;AAVd;AAaY;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAXd;AAcY;EACE,eAAA;EACA,cAAA;AAZd;AAgBU;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;AAdZ;AAgBY;EACE,WAAA;EACA,WAAA;AAdd;AAiBY;EACE,eAAA;EACA,cAAA;AAfd;AAqBM;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAnBR;AAqBQ;EACE,mBAAA;AAnBV;AAsBQ;EACE,gBAAA;EACA,mBAAA;AApBV;AA0BE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;AAxBJ;AA0BI;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;AAxBN;AA0BM;EACE,uBAAA;EACA,cAAA;AAxBR;AA0BQ;EACE,mBAAA;AAxBV;AA4BM;EACE,mBAAA;EACA,WAAA;AA1BR;AA4BQ;EACE,mBAAA;AA1BV","sourcesContent":[".thumbnail-dialog {\n  padding: 24px;\n  min-width: 600px;\n  max-width: 800px;\n\n  .dialog-header {\n    margin-bottom: 24px;\n\n    h2 {\n      font-size: 20px;\n      font-weight: 500;\n      color: #030303;\n      margin: 0 0 8px 0;\n    }\n\n    p {\n      font-size: 14px;\n      color: #606060;\n      margin: 0;\n    }\n  }\n\n  .dialog-content {\n    margin-bottom: 24px;\n  }\n\n  .thumbnail-options {\n    display: flex;\n    gap: 16px;\n    flex-wrap: wrap;\n\n    .option-card {\n      flex: 1;\n      min-width: 280px;\n      border: 2px solid #e0e0e0;\n      border-radius: 8px;\n      padding: 16px;\n      cursor: pointer;\n      transition: all 0.2s;\n\n      &:hover {\n        border-color: #ccc;\n      }\n\n      &.selected {\n        border-color: #065fd4;\n        background-color: #f0f7ff;\n      }\n\n      .option-header {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        margin-bottom: 12px;\n\n        input[type=\"radio\"] {\n          width: 18px;\n          height: 18px;\n          cursor: pointer;\n        }\n\n        label {\n          font-size: 14px;\n          font-weight: 500;\n          color: #030303;\n          cursor: pointer;\n          margin: 0;\n        }\n      }\n\n      .thumbnail-preview {\n        width: 100%;\n        height: 200px;\n        border: 1px solid #e0e0e0;\n        border-radius: 4px;\n        overflow: hidden;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background: #f9f9f9;\n\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n        }\n\n        .no-thumbnail {\n          color: #909090;\n          font-size: 14px;\n        }\n\n        .upload-area {\n          width: 100%;\n          height: 100%;\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          justify-content: center;\n          gap: 12px;\n\n          .upload-label {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            gap: 8px;\n            cursor: pointer;\n            padding: 20px;\n            border-radius: 4px;\n            transition: background-color 0.2s;\n\n            &:hover {\n              background-color: #f0f0f0;\n            }\n\n            mat-icon {\n              font-size: 48px;\n              width: 48px;\n              height: 48px;\n              color: #606060;\n            }\n\n            span {\n              font-size: 14px;\n              color: #606060;\n            }\n          }\n\n          .upload-progress {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            gap: 8px;\n            width: 100%;\n            padding: 0 20px;\n\n            progress {\n              width: 100%;\n              height: 8px;\n            }\n\n            span {\n              font-size: 12px;\n              color: #606060;\n            }\n          }\n        }\n      }\n\n      .upload-btn {\n        margin-top: 12px;\n        width: 100%;\n        padding: 10px;\n        background: #065fd4;\n        color: #fff;\n        border: none;\n        border-radius: 4px;\n        font-size: 14px;\n        font-weight: 500;\n        cursor: pointer;\n        transition: background-color 0.2s;\n\n        &:hover:not(:disabled) {\n          background: #0d47a1;\n        }\n\n        &:disabled {\n          background: #ccc;\n          cursor: not-allowed;\n        }\n      }\n    }\n  }\n\n  .dialog-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    padding-top: 16px;\n    border-top: 1px solid #e0e0e0;\n\n    button {\n      padding: 10px 24px;\n      border-radius: 18px;\n      font-size: 14px;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.2s;\n      border: none;\n\n      &.btn-secondary {\n        background: transparent;\n        color: #030303;\n\n        &:hover {\n          background: #f0f0f0;\n        }\n      }\n\n      &.btn-primary {\n        background: #065fd4;\n        color: #fff;\n\n        &:hover {\n          background: #0d47a1;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
